export default __webpack_public_path__ + "cd7f2bbfd2fbca9d61704316314caf6a.svg";